import React from 'react';
import Meta from '../../shared/Meta';
import PrivacyPolicy from '../../shared/PrivacyPolicy';

import styles from '../../../../stylesheets/public/layouts/AboutPage.module.postcss';

function Privacy() {
  return (
    <div>
      <Meta
        title='Privacy Policy'
        breadcrumbName='Privacy Policy'
      />
      <h2 className={styles.PrivacyPage_header}>Curbside Provisions Privacy Policy</h2>

      <div className={styles.AboutPage_body}>
        <PrivacyPolicy isPublic />
      </div>
    </div>
  );
}

export default Privacy;
